import {t} from '../../../../common/getTranslations';
import {requestContext} from '../../../../common/requestContext';
import {formatWithCommas} from '../../../../common/shared/utils/formatWithCommas';
import {Grid} from '../../../../design-system/atoms/Grid/Grid';
import {Text} from '../../../../design-system/atoms/Text/Text';
import {ListViewGroup} from '../../../../graphql/generated/types';
import {CommonGroupProps} from '../../type';

export function ThumbnailGrid({children, group}: CommonGroupProps) {
  const {isMobile} = requestContext.requestInfo.display;
  // 오늘 신작, 오늘 UP에서만 사용되는 데이터 입니다.
  const {meta} = group as ListViewGroup;

  return (
    <>
      {meta && (
        <div className="mb-4pxr flex h-44pxr w-full justify-between px-4pxr pt-15pxr pb-7pxr">
          {meta.title && (
            <Text className="font-medium1-bold text-theme-solid-100">
              {meta.title}
            </Text>
          )}
          {meta.count && (
            <Text className="font-small2 text-theme-solid-40">
              {t('landing_new_content_series_count', {
                values: {
                  value: formatWithCommas(meta.count),
                },
              })}
            </Text>
          )}
        </div>
      )}
      <Grid gapPx={4} cols={isMobile ? 3 : 6} foldableCols={6}>
        {children}
      </Grid>
    </>
  );
}
